$(document).ready(function(){

	// -- toggle dropdown menu --
	$('.dropdown__toggle').on('click', function(){
		$(this).parents('.dropdown').toggleClass('open');
	});

	// -- close dropdown menu when click outside --
  $(document).mouseup(function(e){
    var container = $('.dropdown');
    if (!container.is(e.target) && container.has(e.target).length === 0){
  		$('.dropdown').removeClass('open');
    }
	});

});